import React from "react";

const Footer: React.FC = () => (
  <>
    <hr className="w-full h-px border-t border-white/40 [border-style:dashed]" />
    <footer className="w-full py-8 md:py-16 flex justify-center items-center flex-wrap gap-8">
      <figure>
        <figcaption className="text-Colors-white text-base font-normal mb-4">
          Empresa colaboradora
        </figcaption>
        <img
          src="/images/cein.svg"
          alt="Logotipo de CEIN"
          className="h-12 w-32 md:h-16 md:w-48"
        />
      </figure>
      <figure>
        <figcaption className="text-Colors-white text-base font-normal mb-4">
          Organiza
        </figcaption>
        <img
          src="/images/jakala.svg"
          alt="Logotipo de JAKALA"
          className="h-12 w-32 md:h-16 md:w-48"
        />
      </figure>
    </footer>
  </>
);

export default Footer;
